import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../../consts'
import {CreateDalogMaintenanceNotificationActionDto} from '../../../types'

import {DalogActionQueryKey} from './useDalogAction'

type Params = {
  plantUpmId?: string
  externalId: string
}

export const useCreateDalogActionMaintenanceNotification = (
  {plantUpmId, externalId}: Params,
  options?: UseMutationOptions<string, AxiosError, CreateDalogMaintenanceNotificationActionDto>
) => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const path = `${TasksApiPath.DALOG_ACTIONS}/${plantUpmId}/dalog-actions/${externalId}/maintenance-notification`

  return useMutation<string, AxiosError, CreateDalogMaintenanceNotificationActionDto>({
    mutationKey: [DalogActionQueryKey, externalId, plantUpmId],
    ...options,
    mutationFn: async (data) => {
      const response = await ApiClient.axiosInstance.post<string>(path, {
        sourceEventId: externalId,
        ...data
      })
      return response.data
    },
    onError: (...args) => {
      spawnErrorToast(t('dalogActions.message.failedToCreateMaintenanceNotification'))
      options?.onError?.(...args)
    },
    onSuccess: async (...args) => {
      spawnSuccessToast(t('dalogActions.message.maintenanceNotificationCreated'))
      await queryClient.invalidateQueries({
        queryKey: [DalogActionQueryKey],
        refetchType: 'all'
      })
      options?.onSuccess?.(...args)
    }
  })
}
